import {
  ProcessingActionTypes,
  IFetchProcessingInfoPayload,
  IFetchProcessingInfoSuccessResponseBody,
  IFetchCurrentProcessingStepPayload,
  IFetchCurrentProcessingStepSuccessResponseBody
} from './types'

export const fetchProcessingInfo = (payload: IFetchProcessingInfoPayload) => ({
  type: ProcessingActionTypes.FETCH_PROCESSING_INFO,
  payload
})

export const fetchProcessingInfoSuccess = (payload: IFetchProcessingInfoSuccessResponseBody) => ({
  type: ProcessingActionTypes.FETCH_PROCESSING_INFO_SUCCESS,
  payload,
})

export const fetchProcessingInfoSuccessForDownloading = () => ({
  type: ProcessingActionTypes.FETCH_PROCESSING_INFO_SUCCESS_FOR_DOWNLOADING,
})

export const fetchCurrentProcessingStep = (payload: IFetchCurrentProcessingStepPayload) => ({
  type: ProcessingActionTypes.FETCH_CURRENT_PROCESSING_STEP,
  payload
})

export const fetchCurrentProcessingStepSuccess = (payload: IFetchCurrentProcessingStepSuccessResponseBody) => ({
  type: ProcessingActionTypes.FETCH_CURRENT_PROCESSING_STEP_SUCCESS,
  payload,
})
